import { Chip, Tooltip } from '@mui/material';
import { STATUS_LABEL, STATUS_COLOR } from '../utils/scenarioState';

// Single place that turns a raw scenario/batch status string into a consistent chip.
// Keeps EMPTY/ERROR/UNKNOWN distinguishable instead of collapsing everything into "success".
export default function ScenarioStatus({ status, reason }) {
  const label = STATUS_LABEL[status] || status || 'Unknown';
  const color = STATUS_COLOR[status] || 'default';
  const chip = <Chip size="small" label={label} color={color} variant={color === 'default' ? 'outlined' : 'filled'} />;
  if (reason) {
    return <Tooltip title={reason}>{chip}</Tooltip>;
  }
  return chip;
}
